export default __webpack_public_path__ + "static/media/project-normal.83d48687.svg";